var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShelves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 31H27",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 16H27",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H27",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5H6C4.89543 4.5 4 5.39543 4 6.5V10.5C4 11.6046 4.89543 12.5 6 12.5H10C11.1046 12.5 12 11.6046 12 10.5V6.5C12 5.39543 11.1046 4.5 10 4.5Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 19.5H18.2002C17.0956 19.5 16.2002 20.3954 16.2002 21.5V25.5C16.2002 26.6046 17.0956 27.5 18.2002 27.5H22.2002C23.3048 27.5 24.2002 26.6046 24.2002 25.5V21.5C24.2002 20.3954 23.3048 19.5 22.2002 19.5Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelves);
export default __webpack_public_path__ + "static/media/shelves.4f0b262a084cf6e03b5b3038c839eb61.svg";
export { ForwardRef as ReactComponent };